import { createContext, useContext, useState, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); }
    catch { return null; }
  });

  const login = useCallback(async (username, password, recaptchaToken) => {
    const res = await api.post('/auth/login.php', { username, password, recaptcha_token: recaptchaToken });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user',  JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  }, []);

  // Verifica si el usuario tiene un permiso específico
  // Uso: can('ventas.crear'), can('productos.gestionar')
  const can = useCallback((permiso) => {
    return user?.permisos?.includes(permiso) ?? false;
  }, [user]);

  const isAdmin = user?.roles?.includes('Administrador') ?? false;

  return (
    <AuthContext.Provider value={{ user, login, logout, can, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return ctx;
};
